import dayjs from 'dayjs';

export function getInicioEFimDoMes() {
  const inicioDoMes = dayjs
    .tz(
      `${dayjs().startOf('month').format('DD/MM/YYYY')} 00:00:00`,
      'DD/MM/YYYY HH:mm:ss',
      'America/Manaus',
    )
    .utc()
    .format();

  const finalDoMes = dayjs
    .tz(
      `${dayjs().endOf('month').format('DD/MM/YYYY')} 23:59:59`,
      'DD/MM/YYYY HH:mm:ss',
      'America/Manaus',
    )
    .utc()
    .format();

  return [inicioDoMes, finalDoMes];
}

export function getInicioEFimDoDia() {
  const inicioDoDia = dayjs
    .tz(
      `${dayjs().format('DD/MM/YYYY')} 00:00:00`,
      'DD/MM/YYYY HH:mm:ss',
      'America/Manaus',
    )
    .utc()
    .format();

  const finalDoDia = dayjs
    .tz(
      `${dayjs().format('DD/MM/YYYY')} 23:59:59`,
      'DD/MM/YYYY HH:mm:ss',
      'America/Manaus',
    )
    .utc()
    .format();

  return [inicioDoDia, finalDoDia];
}
